<template>
  <!-- L22 热力图 -->
  <div class="container l22_heatmap_wrap">
    <PageHeader style="margin:10px 0 0 0;"/>
    <div class="page_searcher">
      <Searcher :items="config.searchers" @search="getData" ref="searcher"/>
    </div>
    <div>
      <div class="page_block" v-if="modules[0].no_chart!=true">
          <h3>{{modules[0].chart.title}}</h3>
          <div class="page_block_content">
            <div style="position:relative;">
              <div class="nodata_chart" ref="nodata" :style="{color:'rgba(0, 0, 0, 0.45)', background:'#fbfbfb', lineHeight:`500px`, textAlign:'center'}"  v-if="datas[0].length === 0 || change">
                  无数据
              </div>
              <div :style="{width: `${wrapInfo.chartWH.width}px`, margin:'0 auto', paddingTop: '48px'}" v-if="showDefaultImg">
                <img :src="wrapInfo.imgSrc" width="100%" />
              </div>
              <div :style="{width: `${wrapInfo.chartWH.width}px`, margin:'0 auto'}">
                <v-chart id="l22_chart_heatmap" :force-fit="true" :width="wrapInfo.chartWH.width" :height="wrapInfo.chartWH.height" :data="datas[0]" :scale="chart.scale" :filter="chart.filter" :padding="[48,0,0,0]" v-if="datas[0].length > 0 && !change && !showDefaultImg" >
                  <!-- 热力图 -->
                  <v-point v-if="heatmap.point" :position="`${chart.conf.x.id}*${chart.conf.y.id}`" :color="[chart.conf.series.id, '#F51D27-#FA541C-#FF8C12-#FFC838-#FAFFA8-#80FF73-#12CCCC-#1890FF-#6E32C2']"  
                      :size="3" :opacity="0.65"  shape="circle" :tooltip="chart.tooltip"/>
                  <v-series v-if="heatmap.heat" 
                      quickType="heatmap" :position="`${chart.conf.x.id}*${chart.conf.y.id}`" :opacity="0"  :color="[chart.conf.series.id, '#F51D27-#FA541C-#FF8C12-#FFC838-#FAFFA8-#80FF73-#12CCCC-#1890FF-#6E32C2']" 
                      :tooltip="chart.tooltip"
                  />
                  <v-guide type="image" :start="['min', 'max']" :end="['max', 'min']" :src="wrapInfo.imgSrc" />

                  <!-- 坐标系默认位置 -->
                  <template v-if="heatmap.default">
                     <v-guide v-for="loc in defaultLoc" :key="loc.position" type="html" :position="loc.position" :html="loc.label" :top='false' />
                  </template>
                  <!-- 坐标系原点 -->
                  <v-guide type="html" :position="[0,0]" :html="oriPoint" :top='false' />

                  <v-legend :allowAllCanceled="true" :position="'top-center'" :offsetY="-10" clickable="true" reversed="false"/>
                  <v-tooltip :showTitle="false" itemTpl='<li data-index={index}><span style="background-color:{color};" class="g2-tooltip-marker"></span>{name} {value}</li>' />
                </v-chart>
                <div style="text-align:center">
                    <a-checkbox :checked="heatmap.point" @change="changeHeatmap($event, 'point')">显示点层</a-checkbox>
                    <a-checkbox :checked="heatmap.heat" @change="changeHeatmap($event, 'heat')">显示热力层</a-checkbox>
                    <!-- <a-checkbox :checked="heatmap.default" @change="changeHeatmap($event, 'default')">显示默认Icon</a-checkbox> -->
                </div>

              </div>
            </div>
          </div>
      </div>
      <div class="page_block" v-if="modules[0].no_table!=true">
          <h3>{{modules[0].name}}
              <a-button-group style="float:right; margin:0 0 0 10px" >
                  <a-button @click="lockHeader(0)" :type="locks.indexOf(0)>=0?'primary':null"><a-icon type="lock" />{{locks.indexOf(0)>=0?$t("common.cancelFix"):$t("common.fixHead")}}</a-button>
                  <a-button @click="exportToExcel(0)"><a-icon type="download"/>{{$t("common.downloadData")}}</a-button>
                  <a-button @click="copy(0)" id="copy-btn"><a-icon type="copy"/>{{$t("common.copyData")}}</a-button>
              </a-button-group>
          </h3>
          <div class="page_block_content">
              <DataTable v-if="modules[0].no_table!=true" :liucun="modules[0].liucun" :fields="modules[0].fields" :theads="modules[0].theads" 
              :datas="datas[0]" ref="datatable_0" :pageSize="config.pageSize" :marks="marks" :color="config.color" :xlen="modules[0].xlen"/>
          </div>
      </div>
    </div>
  </div>
</template>  

<script>
import PageHeader from '@/components/game/pageheader.vue'
import {ctrlMixin} from '@/utils/ctrlMixin.js'
import Searcher from '@/components/common/search/searcher.vue'
import DataTable from '@/components/common/datatable.vue'
import Chart from '@/components/common/chart/chart.vue'
import { format } from '@/utils/chart'
import Vue from 'vue'
import Viser from 'viser-vue';
import _ from 'lodash';

Vue.use(Viser)

const getSelectByFix = (cInfo, curVal) => {
  let res = '';
  if (cInfo.prefix && curVal.startsWith(cInfo.prefix)) {
    res = curVal.substring(cInfo.prefix.length);
  }
  if (cInfo.suffix && curVal.endsWith(cInfo.suffix)) {
    res = res.substring(0, res.length - cInfo.suffix.length);
  }

  res = res.replaceAll('\'', '');
  return res;
}

const DEFAULT_MOBILE_WIDTH = 2400;
const DEFAULT_MOBILE_HEIGHT = 1080;

const DEFAULT_IPAD_WIDTH = 1920;

export default {
    mixins: [ctrlMixin],
    components: {
        Searcher,
        DataTable,
        Chart,
        PageHeader
    },
    mounted() {
      //
    },
    computed: {
      chart() {
        const chartConf = this.modules[0].chart;
        let value_title = chartConf.series&&chartConf.series.title?chartConf.series.title:'值';
        const { xMin, xMax, yMin, yMax } = this.defaultOriPoint;

        return {
          scale: [{
            dataKey: chartConf.x.id,
            type: "linear",
            min: xMin,
            max: xMax,
            nice: false
          }, {
            dataKey: chartConf.y.id,
            type: "linear",
            min: yMin,
            max: yMax,
            nice: false
          }, {
            dataKey: chartConf.series.id,
            type: "linear"
          }],
          filter: [],
          conf: chartConf,
          tooltip: [
            `${chartConf.x.id}*${chartConf.y.id}*${chartConf.series.id}`, 
            (x, y, value) => ({ 
              name: `x:${x} y:${y}`, 
              value:`<br/>${value_title}:${format(value)}`
            })
          ]
        }
      },
      wrapInfo() {
        const { dev } = this.searchParams;
        // width / height < 2.01 为ipad
        const selectedIpad = dev && dev.indexOf('<') > -1;
        const realDefaultWidth = selectedIpad ? DEFAULT_IPAD_WIDTH : DEFAULT_MOBILE_WIDTH;

        return {
          defaultWidth: realDefaultWidth,
          chartWH: {
            width: realDefaultWidth / 2,
            height: DEFAULT_MOBILE_HEIGHT / 2 + 48,
          },
          imgSrc: selectedIpad ? `${require('@/assets/img/ctrl/l22/l22_pad.jpg')}` : `${require('@/assets/img/ctrl/l22/l22_phone.jpg')}`
        }
      },
      // selectedInfo() {
      //   const { searchers } = this.config;
      //   const { wh, widgets } = this.searchParams;
      //   // 选择分辨率
      //   const resWH = getSelectByFix(searchers[2] || {}, wh);
      //   const [sWidth, sHeight] = resWH.split('*');
      //   // 选择widget_id
      //   const sWId = getSelectByFix(searchers[1] || {}, widgets);
      //   return {
      //     sWidth: sWidth || 1000,
      //     sHeight: sHeight || 500,
      //     sWId,
      //   }
      // },
      defaultLoc() {
        this.change = true
        this.$nextTick(()=>{
            this.change = false
        })
        return _.unionWith(this.datas[0] || [], (prev, next) => {
          return Math.round(prev.default_offset_x) === Math.round(next.default_offset_x) && Math.round(prev.default_offset_y) === Math.round(next.default_offset_y)
        }).map(loc => ({
          position: [Math.round(loc.default_offset_x), Math.round(loc.default_offset_y)],
          label: `<div style="display:flex; align-items:center;justify-content: center;width: 60px;height:60px;border: 1px solid #B42B51;color: #fff;border-radius: 50%;">默认</div>`
        }));
      },
      defaultOriPoint() {
        if (this.datas.length > 0) {
          const d = this.datas[0];
          if (d.length > 0) {
            const { anchor_x, anchor_y } = d[0];
            return {
              xMin: -anchor_x * this.wrapInfo.defaultWidth,
              xMax: (1 - anchor_x) * this.wrapInfo.defaultWidth,
              yMin: -anchor_y * DEFAULT_MOBILE_HEIGHT,
              yMax: (1 - anchor_y) * DEFAULT_MOBILE_HEIGHT
            }
          }
        }
        return {
          xMin: 0,
          xMax: this.wrapInfo.defaultWidth,
          yMin: 0,
          yMax: DEFAULT_MOBILE_HEIGHT
        }
      },
      showDefaultImg() {
        return this.datas[0].length > 0 && (!this.heatmap.point && !this.heatmap.heat)
      }
    },
    methods: {
      // 获取页面数据
      getData(params) {
          this.loading = true
          this.searchParams = params;
          
          this.$service.query(this.queryId, params).then((data)=>{
              this.datas = data
              this.loading = false
          }).catch((data)=> {
              this.loading = false
          })
      },
      changeHeatmap(e, type) {
        switch (type) {
          case 'point':
            this.heatmap.point = e.target.checked;
            break;
          case 'heat':
            this.heatmap.heat = e.target.checked;
            break;
          case 'default':
            this.heatmap.default = e.target.checked
          default:
            break;
        }
        // 
        this.change = true
        this.$nextTick(()=>{
            this.change = false
        })
      },
    },
    data() {
        return {
          datas:[[]],
          current:0,
          change: false,
          heatmap: {
            point: true,
            heat: true,
            default: false,
          },
          searchParams: {},
          oriPoint: `<img title="锚点" src="${require('@/assets/img/star.png')}" style="display:inline-block;width: 24px;height:24px;" >`
        }
    },
}
</script>

<style lang="less">
.l22_heatmap_wrap {
  .g-guide {
    pointer-events: none;
  }
}
</style>